import { executeRequest, Request } from '@jfs/network'
import { AgentInfo } from '../data/models/Agent'
import { RootStore } from '../data/store'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'

export const SUCCESS = 'SUCCESS'
export const INITIATED = 'INITIATED'
export const SUBMITTED = 'SUBMITTED'
export const FAILED = 'FAILED'
export const REASON_NOT_FOUND = 'Error reason not found on API'

const responseParser = (data: any) => {
  return data?.data
}

export const sendEvent = (tokens: any, eventName: string, rest: any, agent: typeof AgentInfo.properties) => {
  let config = sitConfig(tokens) as any
  if (!RootStore?.bcAppInfo?.userAccessToken) {
  }
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  const reqBody = getSendEventBody(eventName, { ...rest, agentId: agent?.agentUserLoginId })
  const request: Request<{}> = {
    apiPath: APIEndPoints.sendEvent,
    method: 'POST',
    config: config,
    body: reqBody,
  }
  console.log('Event reqBody ==> ', reqBody)
  // debugger
  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .catch((error) => {
      console.log('no error', error)
    })
}

const getSendEventBody = (eventName: string, rest: any) => {
  const {
    status = 'SUCCESS',
    transactionId = null,
    referenceNumber = null,
    transactionStage = null,
    payeeAccountNumber = null,
    payerAccountNumber = null,
    transactionAmount = null,
    agentId = null,
    errorCode = null,
    errorDescription = null,
    biometricDeviceInfo = null,
    traceId,
  } = rest ?? {}
  return {
    initiatingModule: 'ATS',
    initiatingSubModule: 'BC_APP',
    traceId,
    transactionDescription: eventName,
    initiatingEntityId: RootStore.agent.session.CHANNEL_ID,
    status,
    transactionId,
    referenceNumber,
    transactionStage,
    payeeAccountNumber,
    payerAccountNumber,
    transactionAmount,
    agentId,
    errorCode,
    errorDescription,
    biometricDeviceInfo,
  }
}

const eventList = []

export const sendEventApiScheduled = (tokens: any, request: any, extraParams = {}) => {
  console.log('htag request=', request)
  const reqBody = getRequestBody(request, extraParams)
  eventList.push({ reqBody, tokens })
}

export const fireAllScheduledEvent = () => {
  eventList.forEach((item) => {
    fireSingleEventApi(item.tokens, item.reqBody)
  })
  eventList.length = 0
}

const fireSingleEventApi = (tokens, requestBody) => {
  console.log('htag request=', requestBody)
  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  config.headers['x-app-access-token'] = RootStore?.agent?.session.appAccessToken
  config.headers['x-appid-token'] = RootStore?.agent?.session?.appIdToken
  const sendEventReq: Request<{}> = {
    apiPath: APIEndPoints.sendEvent,
    method: 'POST',
    config: config,
    body: requestBody,
  }
  return executeRequest(sendEventReq).catch((error) => {
    console.log('error sending event', error)
  })
}

export const sendEventApi = (tokens: any, request: any, extraParams = {}) => {
  console.log('htag request=', request)
  let config = sitConfig(tokens) as any
  if (!RootStore?.bcAppInfo?.userAccessToken) {
    console.log('Skipping event api as user token are missing')
    return Promise.resolve({
      message: 'User token not generated',
    })
  }
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  config.headers['x-app-access-token'] = RootStore?.agent?.session.appAccessToken
  config.headers['x-appid-token'] = RootStore?.agent?.session?.appIdToken
  const reqBody = getRequestBody(request, extraParams)
  const sendEventReq: Request<{}> = {
    apiPath: APIEndPoints.sendEvent,
    method: 'POST',
    config: config,
    body: reqBody,
  }
  return executeRequest(sendEventReq).catch((error) => {
    console.log('error sending event', error)
  })
}

export const getRequestBody = (request, extraParams: any) => {
  console.log('request?.config?.headers', request?.config?.headers)
  return {
    initiatingModule: 'ATS',
    initiatingSubModule: 'BC_APP_' + SUB_MODULES?.[RootStore.consents?.appType],
    traceId: request?.config?.headers?.['x-trace-id'],
    transactionDescription: request?.apiPath,
    initiatingEntityId: RootStore.agent.session.CHANNEL_ID,
    agentId: RootStore.agent.agentInfo.agentUserLoginId,
    //status,
    ...extraParams,
    /* transactionId,
    referenceNumber,
    transactionStage,
    payeeAccountNumber,
    payerAccountNumber,
    transactionAmount,
    errorCode,
    errorDescription,
    biometricDeviceInfo:,//SHOULD HAVE MODE ALSO FACE/FINGER_PRINT*/
  }
}

const SUB_MODULES = {
  '0': 'AEPS',
  '1': 'DMR',
  '2': 'REFUND',
}
